module.exports = "img/flags/LV.7ceac79.png";